import React, { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import Header from '../components/Header';
import HeroSectionPortfolio from '../components/HeroSection_portfolio';
import PortfolioSection from '../components/PortfolioSection';
import AboutB2Section from '../components/AboutB2Section';
import VisionMissionSection from '../components/VisionMissionSection';
import DesignTools from '../components/DesiginTools';
import Footer from '../components/Footer';

// Wrapper component for animated sections
const AnimatedSection = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { 
          opacity: 1, 
          y: 0,
          transition: { 
            duration: 0.0, 
            ease: "easeOut",
            delay: delay 
          }
        }
      }}
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

const OurWorkPage = () => (
  <>
    <Header />
    <main style={{ width: '100%', overflow: 'hidden' }}>
      <AnimatedSection>
        <HeroSectionPortfolio />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <PortfolioSection />
      </AnimatedSection>
    </main>
    <Footer />
  </>
);

export default OurWorkPage;